import { tickerItems, statusMeta } from "@/mocks/home";

export default function TopRail() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="mx-auto flex h-11 max-w-shell items-center gap-4 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-2 whitespace-nowrap font-label text-[11px] tracking-[0.28em] text-accent-400">
          <span className="flex h-4 w-4 items-center justify-center">
            <span className="pulse-dot block h-1.5 w-1.5 rounded-full bg-accent-400" />
          </span>
          在线入口条
        </span>

        <span className="hidden h-4 w-px shrink-0 bg-background-100/25 sm:block" />

        <div className="relative flex-1 overflow-hidden">
          <div className="marquee-track">
            {loopItems.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="mr-10 font-label text-xs text-background-200/90"
              >
                {item}
              </span>
            ))}
          </div>
        </div>

        <span className="hidden shrink-0 items-center gap-2 whitespace-nowrap font-label text-[11px] text-background-300 md:flex">
          <i className="ri-time-line text-sm" />
          更新于 {statusMeta.updatedAt}
        </span>
      </div>
    </div>
  );
}